const strings = {
	en: {
		placeholder: "Search a game..."
	},
	es: {
		placeholder: "Buscar un juego..."
	}
};

export default strings;